<template>
    <div class="password-requirements">
        <div>Password requirements</div>
        <div>
            <ul class="check-list">
                <li :class="getStatusClass('lowerCaseLetters')"><i :class="getStatusIcon('lowerCaseLetters')"></i>
                    Minimum lower case letters (ex: a,b,c) required:
                    {{ requirements.password_min_lower_case_letters }}
                </li>
                <li :class="getStatusClass('upperCaseLetters')"><i :class="getStatusIcon('upperCaseLetters')"></i>
                    Minimum upper case letters (ex: A,B,C) required:
                    {{ requirements.password_min_upper_case_letters }}
                </li>
                <li :class="getStatusClass('minimumLength')"><i :class="getStatusIcon('minimumLength')"></i> Minimum
                    password length: {{ requirements.minimum_password_length }}
                </li>
                <li :class="getStatusClass('characters')"><i :class="getStatusIcon('characters')"></i> Minimum amount of
                    letters (not a number or a special character) required: {{
                        requirements.password_min_alphanumeric
                    }}
                </li>
                <li :class="getStatusClass('specialCharacters')"><i :class="getStatusIcon('specialCharacters')"></i>
                    Minimum amount of special characters (!,$,*, etc.) required:
                    {{ requirements.password_min_special_characters }}
                </li>
                <li :class="getStatusClass('invalidCharacters')"><i :class="getStatusIcon('invalidCharacters')"></i>
                    Does not have any invalid characters (|, space, etc.):
                    {{ requirements.invalidCharacters }}
                </li>
                <li :class="getStatusClass('passwordsMatch')"><i :class="getStatusIcon('passwordsMatch')"></i>
                    Passwords match
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import {onMounted, reactive, watch} from "vue";
import {getPasswordErrors} from "@/lib/check-password";

export default {
    name: "PasswordRequirementsValidator",
    props: {
        password: String,
        confirmPassword: String,
        requirements: Object
    },
    setup(props) {
        const passwordValidation = reactive({
            lowerCaseLetters: 'fail',
            upperCaseLetters: 'fail',
            minimumLength: 'fail',
            characters: 'fail',
            specialCharacters: 'fail',
            passwordsMatch: 'fail',
        });

        const checkPassword = () => {
            const errors = getPasswordErrors(props.password, props.requirements);
            passwordValidation.lowerCaseLetters = errors.includes('password_min_lower_case_letters') ? 'fail' : 'success';
            passwordValidation.upperCaseLetters = errors.includes('password_min_upper_case_letters') ? 'fail' : 'success';
            passwordValidation.characters = errors.includes('password_min_alphanumeric') ? 'fail' : 'success';
            passwordValidation.specialCharacters = errors.includes('password_min_special_characters') ? 'fail' : 'success';
            passwordValidation.minimumLength = errors.includes('minimum_password_length') ? 'fail' : 'success';
            passwordValidation.invalidCharacters = errors.includes('invalid_characters') ? 'fail' : 'success';
            passwordValidation.passwordsMatch = props.password !== props.confirmPassword || props.password === '' ? 'fail' : 'success';
        }

        const getStatusClass = (field) => {
            if (passwordValidation[field] === 'fail') {
                return 'fail';
            }

            return 'pass';
        };


        const getStatusIcon = (field) => {
            if (passwordValidation[field] === 'fail') {
                return 'far fa-times-circle';
            }

            return 'far fa-check-circle';
        };

        watch(() => props.password, () => checkPassword());
        watch(() => props.confirmPassword, () => checkPassword());

        onMounted(() => checkPassword());

        return {
            getStatusClass,
            getStatusIcon
        };
    }
}
</script>

<style scoped lang="scss">
.password-requirements {
    .check-list {
        list-style-type: none;
        padding-left: 20px;

        li.pass {
            color: #769d28;
        }

        li.fail {
            color: #bd2130;
        }
    }
}
</style>